__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-scs/v6_5_0/";